module.exports = __webpack_public_path__ + "cac6863cf078c487d4cf5f5cb9d0bac1.png";